import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { COMPONENTS, IMPORTS, SERVICES } from '.';
import { AppComponent } from './app.component';
import { TokenInterceptor } from './interceptors/token.interceptor';

@NgModule({
  declarations: [
    ...COMPONENTS,
  ],
  imports: [
    ...IMPORTS
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    ...SERVICES
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
